"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parser_1 = require("./parser");
/**
 * @class
 */
const Visitors = {
    /**
     * Visit `selector` node
     *
     * @param {Object} node
     * @param {Object|Array} ctx
     * @param {State} state
     */
    selector(node, ctx, state) {
        ctx = traverse(node.prefix, ctx, state);
        state.prev = node.prefix;
        return suffixes(node.suffixes, ctx, state);
    },
    /* { token: Token, wildcard: {}} */
    name(node, ctx, state) {
        return wildcard(node, state)(ctx);
    },
    // { start, slice, end }
    array(node, ctx, state) {
        if (!Array.isArray(ctx))
            return;
        // flatten result
        if (state.expand) {
            ctx = flatten(ctx);
            state.expand = !state.expand;
        }
        let start = node.start && node.start.value || 0;
        let end = node.end && node.end.value || ctx.length;
        // slice always returns array `[...]`
        if (node.slice) {
            return ctx.slice(start, end);
        }
        // specific element e.g. `a[1]`
        if (node.start) {
            return ctx[start];
        }
        // all elements e.g. `a[]`
        return ctx;
    },
    property(node, ctx, state) {
        // select many properties from array e.g. `users[].name` but not `users[1].name`
        let prev = state.prev;
        if (prev.type === 'array' && !prev.single || state.expand) {
            // toggle `expand` state
            state.expand = !state.expand;
            ctx = ctx
                .map(wildcard(node.name, state))
                .filter(v => v !== undefined);
            // flatten
            return node.name.wildcard ? flatten(ctx) : ctx;
        }
        // select simple name e.g. `user.name`
        return this.name(node.name, ctx, state);
    },
};
const suffixes = (nodes, ctx, state) => {
    return (nodes || []).reduce((ctx, node, i) => {
        // get previous node first, if failed (at `0` index) use parent node as `prev`
        state.prev = nodes[i - 1] || state.prev;
        return traverse(node, ctx, state);
    }, ctx);
};
const wildcard = (node, state) => ctx => {
    // wildcard e.g. `*name` will match `username`, `firstname`
    let nodeKey = node.token.value;
    if (node.wildcard) {
        // set `expand` flag
        state.expand = true;
        let keys = Object.keys(ctx);
        let { start, end, all } = node.wildcard;
        let r = keys
            .filter(k => {
            if (all)
                return true;
            else if (start && end)
                return k.indexOf(nodeKey) > -1;
            else if (start)
                return k.substr(k.length - nodeKey.length) === nodeKey;
            else if (end)
                return k.substr(0, nodeKey.length) === nodeKey;
            else
                return false;
        })
            .map(k => ctx[k]);
        return r;
    }
    else {
        return ctx[node.token.value];
    }
};
const flatten = xs => xs.reduce((a, b) => a.concat(b), []);
/**
 * Traverse AST and perform selection against given context
 *
 * @param {Object} node      AST nodes
 * @param {Object|Array} ctx Context to perform selection
 * @param {State} state      Visitor's state
 */
function traverse(node, ctx, state) {
    state = state || { expand: false, prev: null };
    if (node.type in Visitors) {
        return Visitors[node.type](node, ctx, state);
    }
    throw new Error(`Invalid node ${node.type}`);
}
exports.default = (selector, data) => traverse(parser_1.parse(parser_1.tokenize(selector)), data, { expand: false, prev: null });
//# sourceMappingURL=data:application/json;base64,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